// extracted by mini-css-extract-plugin
export default {"container":"OtimizacaoPrecos_container__MUBdQ"};